import * as deviceModel from '~/models/device';
import * as studioModel from '~/models/studio';
import type * as schema from '~/models/pulser-schema';

export const parseDeviceChannels = (
  deviceInfo: schema.Device
): deviceModel.KnownChannelData[] => {
  if (typeof deviceInfo === 'string' && deviceInfo === 'MockDevice') {
    return deviceModel.deviceChannels.MockDevice;
  } else {
    return deviceInfo.channels.map((channel) => ({
      addressing: channel.addressing.toLowerCase() as studioModel.Addressing,
      basis: studioModel.importBasis(channel.basis as schema.Basis),
      maxAbsDetuning: channel.max_abs_detuning || 0,
      maxAmp: channel.max_amp || 0,
      minRetargetInterval: channel.min_retarget_interval || 0,
      phaseJumpTime: channel.mod_bandwidth
        ? Math.floor((0.48 / channel.mod_bandwidth) * 1e3) * 2
        : 0,
      fixedRetargetT: channel.fixed_retarget_t || 0,
      maxTargets: channel.max_targets || undefined,
      clockPeriod: channel.clock_period,
      minDuration: channel.min_duration,
      uuid: channel.id,
      maxDuration: channel.max_duration || undefined,
      modBandwidth: channel.mod_bandwidth || undefined,
      enableDetuning:
        channel.addressing.toLowerCase() === 'global' ||
        channel.max_abs_detuning > 0
    }));
  }
};

export const parseDevice = (deviceInfo: schema.Device): studioModel.Device => {
  if (typeof deviceInfo === 'string' && deviceInfo === 'MockDevice') {
    return deviceModel.devices.MockDevice;
  } else {
    return {
      name: deviceInfo.name,
      dimensions: deviceInfo.dimensions,
      rydbergLevel: deviceInfo.rydberg_level,
      maxAtomNum: deviceInfo.max_atom_num || 0,
      maxRadialDistance: deviceInfo.max_radial_distance || 0,
      minAtomDistance: deviceInfo.min_atom_distance
    };
  }
};
